export const ACADEMIES = 'academies';
export const USER = 'user';
